"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _pill = _interopRequireDefault(require("britive-design-system/core/components/pill"));

var _DataTable = _interopRequireDefault(require("../../../data-table/DataTable"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.sa-resource-labels-header-class .header-class {\n  margin-top: 2rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #a8a8a8; }\n  .sa-resource-labels-header-class .header-class .margin-top-32 {\n    margin-top: 2rem; }\n  .sa-resource-labels-header-class .header-class .margin-top-8 {\n    margin-top: 0.5rem; }\n";
  var fileName = "compone_ResourceLabels";
  var element = document.querySelector("style[data-sass-component='compone_ResourceLabels']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

function ResourceLabels(_ref) {
  var _ref$policyViewData = _ref.policyViewData,
      policyViewData = _ref$policyViewData === void 0 ? {} : _ref$policyViewData;
  var columns = [{
    field: 'key',
    headerName: 'Label Key',
    width: '400px',
    renderColumn: function renderColumn(row) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, row === null || row === void 0 ? void 0 : row.key);
    }
  }, {
    headerName: 'Values',
    renderColumn: function renderColumn(row) {
      var _row$values;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, row === null || row === void 0 ? void 0 : (_row$values = row.values) === null || _row$values === void 0 ? void 0 : _row$values.map(function (value) {
        return /*#__PURE__*/_react.default.createElement(_pill.default, {
          readOnly: true,
          label: value,
          key: value
        });
      }));
    }
  }];

  var getTableRowData = function getTableRowData() {
    var _Object$entries;

    var list = (_Object$entries = Object.entries((policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.resourceLabels) || {})) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          values = _ref3[1];

      return {
        key: key,
        values: values
      };
    });
    return list || [];
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.headerClass
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "pageSectionHeader"
  }, " Resource Labels ")), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_DataTable.default, {
    rows: getTableRowData(),
    columns: columns
  }))));
}

ResourceLabels.propTypes = {
  policyViewData: _propTypes.default.object
};
var _default = ResourceLabels;
exports.default = _default;